import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/contact",
    name: "Contact",
    components: require("../views/Contact.vue"),
  },
  {
    path: "/:slug",
    name: "Page",
    components: require("../views/Page.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Error",
    component: Home,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});

export default router;
